<template> 
  <div>
    <a
      class="cart-button cart-button-style"
      href="#"
    >
      <div class="bag-count">
        <i class="fa-solid fa-bag-shopping" />
        <span v-if="$store.getters.updateMiniCart.length > 0">{{ $store.getters.updateMiniCart.length }} Items</span>
        <span v-else>{{ cartItems.length }} Items</span>
      </div>
      <span
        v-if="$store.getters.updateSubTotal!=''"
        class="bag-label"
      >${{ Number($store.getters.updateSubTotal).toFixed(2) }}</span>
      <span
        v-else
        class="bag-label"
      >${{ Number(subtotal).toFixed(2) }}</span>
    </a>

    <aside id="sidebar-cart">
      <main>
        <a
          href="#"
          class="close-button"
        ><span
          ref="closeBtn"
          class="close-icon"
        >X</span></a>
        <h2>
          Shopping Bag 
          <span
            v-if="$store.getters.updateMiniCart.length > 0"
            class="count"
          >{{ $store.getters.updateMiniCart.length }}</span>
          <span
            v-else
            class="count"
          >{{ cartItems.length }}</span>
          <span
            class="text-danger"
            title="Remove all item from bag"
            @click="deleteItems"
          >
            <i class="fa fa-trash" /></span>
        </h2>
               

        <ul
          v-if="$store.getters.updateMiniCart.length > 0"
          class="products"
        >                    
          <li
            v-for="item in $store.getters.updateMiniCart"
            :key="item.id"
            class="product"
          >
            <a
              href="#"
              class="cartProductLink"
            >
              <span class="product-image">
                <img
                  :src="item.product.image"
                  :title="item.product.name"
                  :alt="item.product.name"
                >
              </span>
              <span class="product-details">
                <h3>{{ item.product.name.substring(0,20)+".." }}</h3>
                <span class="qty-price">
                  <span class="qty">
                    <button
                      id="minus-button-1"
                      class="minus-button"
                      @click="$store.dispatch('updateCart', {cart_id:item.id, product_id:item.product.id, quantity:'qtyOne'+item.id, action:'minus'})"
                    >-</button>
                    <input
                      :id="'qtyOne'+item.id"
                      type="number"
                      class="qty-input"
                      step="1"
                      min="1"
                      max="1000"
                      pattern="[0-9]*"
                      :value="item.quantity"
                      readonly
                    >
                    <button
                      class="plus-button"
                      @click="$store.dispatch('updateCart', {cart_id:item.id, product_id:item.product.id, quantity:'qtyOne'+item.id, action:'plus'})"
                    >+</button>
                  </span>
                  <span
                    :id="'priceOne'+item.id"
                    class="price"
                  >${{ Number(item.product.product_inventory.price * item.quantity).toFixed(2) }}</span>
                </span>
              </span>
            </a>
            <a
              href="#"
              class="remove-button"
              @click="$store.dispatch('removeCart', item.id)"
            >
              <span class="remove-icon">X</span>
            </a>
          </li>    
        </ul>

        <ul
          v-else
          class="products"
        >     
          <li
            v-for="(items) in cartItems"
            :key="items.id"
            class="product"
          >
            <a
              href="#"
              class="cartProductLink"
            >
              <span class="product-image">
                <img
                  :src="items.product.image"
                  :title="items.product.name"
                  :alt="items.product.name"
                >
              </span>
              <span class="product-details">
                <h3>{{ items.product.name.substring(0,20)+".." }}</h3>
                <span class="qty-price">
                  <span class="qty">
                    <button
                      id="minus-button-1"
                      class="minus-button"
                      @click="$store.dispatch('updateCart', {cart_id:items.id, product_id:items.product.id, quantity:'qtyTwo'+items.id, action:'minus'})"
                    >-</button>
                    <input
                      :id="'qtyTwo'+items.id"
                      type="number"
                      class="qty-input"
                      step="1"
                      min="1"
                      max="1000"
                      pattern="[0-9]*"
                      :value="items.quantity"
                      readonly
                    >
                    <button
                      class="plus-button"
                      @click="$store.dispatch('updateCart', {cart_id:items.id, product_id:items.product.id, quantity:'qtyTwo'+items.id, action:'plus'})"
                    >+</button>
                  </span>
                  <span
                    :id="'priceTwo'+items.id"
                    class="price"
                  >${{ Number(items.product.product_inventory.price * items.quantity).toFixed(2) }}</span>
                </span>
              </span>
            </a>
            <a
              href="#"
              class="remove-button"
              @click="$store.dispatch('removeCart', items.id)"
            >
              <span class="remove-icon">X</span>
            </a>
          </li> 
        </ul>
        <div class="totals">
          <div class="subtotal">
            <span class="amountLabel">Subtotal:</span>
            <span
              v-if="$store.getters.updateSubTotal!=''"
              class="amount"
            >${{ Number($store.getters.updateSubTotal).toFixed(2) }}</span>
            <span
              v-else
              class="amount"
            >${{ Number(subtotal).toFixed(2) }}</span>
          </div>
          <div class="shipping">
            <span class="amountLabel">Shipping:</span>
            <span class="amount">$0.0</span>
          </div>
          <div class="tax">
            <span class="amountLabel">Tax:</span>
            <span class="amount">$0.0</span>
          </div>
          <div class="amountPayable">
            <span class="amountLabel">Amount Payable:</span>
            <span
              v-if="$store.getters.updateSubTotal!=''"
              class="amount"
            >${{ Number($store.getters.updateSubTotal).toFixed(2) }}</span>
            <span
              v-else
              class="amount"
            >${{ Number(subtotal).toFixed(2) }}</span>
          </div>
          <div class="action-buttons">
            <router-link
              v-if="$store.getters.updateMiniCart.length > 0 || cartItems.length > 0"
              :to="{ path: '#' }"
              class="checkout-button btn-primary"
              @click="goToCheckout"
            >
              Proceed to checkout
            </router-link>
            <router-link
              v-else
              :to="{ path: '#'}"
              class="checkout-button btn-default"
            >
              Cart is Empty
            </router-link>
          </div>
        </div>
        <!-- <div class="action-buttons">
                    <router-link :to="{ path: '#' }" @click="goToCheckout" v-if="$store.getters.updateMiniCart.length > 0 || cartItems.length > 0" class="checkout-button btn-primary">Proceed to checkout</router-link>
                    <router-link :to="{ path: '#'}" v-else class="checkout-button btn-default">Cart is Empty</router-link>
                </div> -->
      </main>
    </aside>
  </div>
</template>
<script>
import axios from '@/utils/axiosConfig';
export default {
    name: 'Minicart', 
    props: ['cartItems','subtotal'],
    methods: {
        goToCheckout(){
             if(this.$store.getters.isAuthenticated){
                this.$router.push('/shipping')
                var elem = this.$refs.closeBtn
                elem.click()
            }
            else{
                this.$router.push({ path: '/checkout-login' })
                var closeEl = this.$refs.closeBtn
                closeEl.click()
            }            
        },
        deleteItems() {
            axios.delete(`cart-delete-all`)
            .then(
            function (response) {
                // console.log(response)
                if (response.data.success) {
                    console.log('Deleted')
                    localStorage.clear();
                    window.location.reload()
                }
            })
            .catch(function (error) {
                console.log(error);
            });            
        }
    }
};
</script>

